import { IUScoreResource, IUserSettings } from 'interfaces';
import { get } from 'lodash/fp';
import { makeAutoObservable } from 'mobx';
export const activeGroupIdKey = '__$ag';
export const activeGroupScroll = '__$agc';
class UserStore {
    constructor() {
        makeAutoObservable(this);
    }
    public uscoresPermissions: IUScoreResource = {
        canEdit: false,
        canDelete: false,
        canScore: false,
    };

    public geoquantFlagsPermission: { [key: string]: boolean } = {
        canSeeArchivedUScores: false,
    };

    public username: string;
    public accessible_apps: string[];
    public allPermissions: object;

    public setUscorePermission(permissions: IUScoreResource) {
        this.uscoresPermissions = permissions;
    }

    public setGeoquantFlagsPermission(permissions: { [key: string]: boolean }) {
        this.geoquantFlagsPermission = permissions;
    }

    public initUser(userSettings: IUserSettings) {
        this.username = get('username', userSettings);
        this.accessible_apps = get('accessible_apps', userSettings);
        this.allPermissions = get('permissions', userSettings);
    }
}
export default new UserStore();
